import React, { useContext } from 'react';
import { renderHeader, shouldHideHeader, shouldHideHeaderForNewConversationUi } from '../../../helpers/header_helper';
import Context from '../../../utils/context';

import styles from './index.module.css';

export default function MemberPlatformNavWrap({ children }) {
  const context = useContext(Context);
  const isMobile = context.viewport.getIsMobile();
  const showHeader =
    !shouldHideHeader(window.location.pathname, isMobile) &&
    !shouldHideHeaderForNewConversationUi(window.location.pathname, context.auth);
  const wrapperStyle = isMobile
    ? { height: `calc(${window.innerHeight}px - var(--impersonation-banner-height, 0px))` }
    : {};

  if (!showHeader) {
    wrapperStyle['--member-platform-header-offset'] = '0px';
  }

  const header = renderHeader(context.auth);

  return (
    <div style={wrapperStyle} className={styles.member_platform_header_wrapper}>
      {showHeader && header}
      <div className={styles.member_platform}>{children}</div>
    </div>
  );
}
